<mat-card style="width: max-content; max-width: 100%;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title class="">
                    Schedules
                </mat-card-title>
                <mat-card-subtitle>
                    Manage schedules and availability
                </mat-card-subtitle>
            </div>
            <div class="right gap-10 g-just-flex" style="flex-wrap: wrap;">
                <a mat-flat-button class="secondary-button small-button">
                    <mat-icon>file_upload</mat-icon> Import
                </a>
                <a mat-flat-button extended class="secondary-button small-button">
                    <mat-icon>file_download</mat-icon> Export
                </a>
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        @if(tableDataSource.data && tableDataSource.data.length > 0){
        <!--   {{tableDataSource.data | json}} schedule(s) found. -->
        <mat-divider></mat-divider>

        <table mat-table [dataSource]="tableDataSource.data" class="mat-elevation-z8 demo-table">


            <!-- Practitioner Column -->
            <ng-container matColumnDef="practitioner">
                <th mat-header-cell *matHeaderCellDef> Practitioner </th>
                <td mat-cell *matCellDef="let element">
                    @let practitionerRefs = getPractitionerReferences(element);
                    @if(practitionerRefs.length){
                    <div class="stacked-cell">
                        @for(practitionerRef of practitionerRefs; track practitionerRef) {
                        <span [appReferenceDisplay]="practitionerRef" [instantFetchAndReplace]="true">
                            {{ practitionerRef }}
                        </span>
                        }
                    </div>
                    } @else {
                    <span class="subtitle-text-color-2">N/A</span>
                    }
                </td>
            </ng-container>

            <!-- Planning Horizon Column -->
            <ng-container matColumnDef="planningHorizon">
                <th mat-header-cell *matHeaderCellDef> Planning Horizon </th>
                <td mat-cell *matCellDef="let element">
                    <div class="g-just-flex gap-8">
                        <div class="g-just-flex flex-column align-items-start">
                            <div class="top">
                                {{ element.planningHorizon?.start | date:'mediumDate' }}
                            </div>
                            <div class="bottom subtitle-text-color-2">
                                <!-- {{ element.planningHorizon?.start | date:'shortTime' }} -->
                            </div>
                        </div>
                        <div class=" btw" style="border: 0px solid var(--mat-sys-outline);
                        border-radius: 50%; height: 24px; width: 24px; display:flex; align-items:center; justify-content:center;
                        ">
                            <span class="material-symbols-outlined"
                                style="width: 16px; height: 16px; font-size: 16px;">arrow_forward</span>
                        </div>
                        <div class="secondary-line">
                            <div class="g-just-flex flex-column align-items-start">
                                <div class="top">
                                    {{ element.planningHorizon?.end | date:'mediumDate' }}
                                </div>
                                <div class="bottom subtitle-text-color-2">
                                    <!-- {{ element.planningHorizon?.end | date:'shortTime' }} -->
                                </div>
                            </div>
                            <!-- End: {{ element.planningHorizon?.end | date:'mediumDate' }} {{ element.planningHorizon?.end | date:'shortTime' }} -->
                        </div>
                    </div>
                </td>
            </ng-container>

            <!-- Slot Count Column -->
            <ng-container matColumnDef="slotCount">
                <th mat-header-cell *matHeaderCellDef> Slots </th>
                <td mat-cell *matCellDef="let element">
                    <span [appEmphasis]="'total'" [opacity]="0.75" style="margin-right: 8px;">Total: {{
                        element.totalSlots || 0 }}</span>
                    <span [appEmphasis]="'free'" [opacity]="0.75" color="primary">Free: {{ element.freeSlots || 0
                        }}</span>
                </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-chip" [class.active]="element.active !== false">
                        {{ element.active === false ? 'Inactive' : 'Active' }}
                    </span>
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button (click)="showScheduleDetails(element)">
                        <mat-icon>visibility</mat-icon>
                    </button>
                    @if(canManageSchedules()) {
                    <button mat-icon-button (click)="editSchedule(element)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="confirmCancelSchedule(element)"
                        [disabled]="isCancelling(element.id)">
                        <mat-icon>{{ isCancelling(element.id) ? 'hourglass_top' : 'event_busy' }}</mat-icon>
                    </button>
                    }
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- </table> -->

            <style>
                table.mat-table td {
                    position: relative;
                    z-index: 2147483647 !important;
                }

                table.mat-table tr {
                    position: relative;
                    z-index: 1;
                }

                .status-chip {
                    display: inline-flex;
                    align-items: center;
                    padding: 0 10px;
                    height: 24px;
                    border-radius: 999px;
                    font-size: 0.85rem;
                    background: rgba(158, 158, 158, 0.15);
                    color: var(--mat-sys-on-surface);
                }

                .status-chip.active {
                    background: rgba(49, 125, 66, 0.15);
                    color: var(--mat-sys-primary);
                }
            </style>
        </table>
        } @else {
        <app-empty-state [icon]="'calendar_today'" [title]="'No Schedules Found'"
            [subtitle]="'Create a new schedule to see it here.'"></app-empty-state>
        }
    </mat-card-content>
</mat-card>
